import { ENUM_COKITCHEN_TEAM, ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import AdminRoleDropdown from 'components/header/admin-role-dropdown';
import useRoleContext from 'contexts/role.context';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getCurrentTeam, getHeaderLinks } from 'utils/role-config';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/arrow-down-icon.svg';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { withDropdownList } from 'components/base/dropdown-list';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const DropdownList = withDropdownList<{ name: string; path: string }>();

const Sidebar = ({ isOpen, onClose }: Props) => {
  const { role } = useRoleContext();
  const tabs = getHeaderLinks();
  const [allTabs, setAllTabs] = useState(tabs);
  const [showDropdown, setShowDropdown] = useState<null | number>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const hideLogisticsSettings =
      getCurrentTeam() === ENUM_COKITCHEN_TEAM.LOGISTICS && role !== ENUM_ROLE.LOGISTICS_ADMIN;
    const allTabs = hideLogisticsSettings ? tabs.filter((t) => t.name !== 'Settings') : tabs;
    setAllTabs(allTabs);
  }, []);

  const navStyles = {
    active:
      'flex  border-b-[3.5px] text-[#858585] cursor-pointer pt-5 pb-2 mb-2 border-b-[#E60A2B]',
    inactive:
      'flex  border-b-[3.5px] text-[#858585] cursor-pointer pt-5 pb-2 mb-2 border-b-transparent'
  };
  return (
    <BaseModal position='right' isOpen={isOpen} onRequestClose={onClose} title=''>
      <div className='flex flex-col justify-start w-fit px-1'>
        <div className='flex flex-col gap-1 '>
          <span className='text-sm text-gray-5'>Active role</span>
          <AdminRoleDropdown />
        </div>
        {allTabs.map(({ path, name, options }, index) => (
          <div key={index}>
            <NavLink
              to={path}
              className={({ isActive }) => (isActive ? navStyles.active : navStyles.inactive)}>
              {name}
              <div>
                {options &&
                  (showDropdown === index ? (
                    <div className='transform rotate-180' onClick={() => setShowDropdown(null)}>
                      <ArrowDownIcon />
                    </div>
                  ) : (
                    <div onClick={() => setShowDropdown(index)}>
                      <ArrowDownIcon />
                    </div>
                  ))}
              </div>
            </NavLink>
            {showDropdown === index && options && (
              <DropdownList
                className='absolute'
                list={options}
                onSelect={(item) => {
                  navigate(item.path);
                  setShowDropdown(null);
                }}
              />
            )}
          </div>
        ))}
      </div>
    </BaseModal>
  );
};

export default Sidebar;
